import { Icon } from "@/components/icon";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { cn } from "@/utils";
import { Link } from "@tanstack/react-router";
import prettyBytes from "pretty-bytes";
import { useState } from "react";

const extensionColors: Record<string, string> = {
	pdf: "bg-red-600",
	csv: "bg-green-700",
	doc: "bg-blue-600",
	docx: "bg-blue-600",
	xls: "bg-green-700",
	xlsx: "bg-green-700",
	ppt: "bg-orange-700",
	pptx: "bg-orange-700",
	txt: "bg-gray-600",
	json: "bg-gray-600",
};

export function Attachment({
	id,
	name,
	size,
	url,
	onRemove,
}: {
	id: string;
	name: string;
	size?: string;
	url: string;
	onRemove?: () => void;
}) {
	const [isHovered, setIsHovered] = useState(false);

	return (
		<Card
			key={id}
			className="flex relative h-14 rounded overflow-hidden flex-row gap-2 items-center justify-start"
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
		>
			<div
				className={cn(
					"uppercase text-white text-sm font-semibold flex items-center justify-center aspect-square size-14 bg-zinc-500",
					extensionColors[name.split(".").at(-1)?.toLowerCase() || "default"],
				)}
			>
				{name.split(".").at(-1)}
			</div>

			<div className="flex flex-col items-start justify-center h-full pr-6">
				<div className="text-foreground text-sm/5">{name}</div>

				{size ? (
					<div className="text-muted-foreground text-xs">
						{prettyBytes(parseInt(size, 10))}
					</div>
				) : null}
			</div>

			{isHovered && typeof onRemove === "function" ? (
				<div className="absolute h-full w-16 right-0 bg-card flex items-center justify-center">
					<div className="h-full w-4 bg-linear-to-r from-transparent to-card" />

					<div className="h-full flex-1 flex items-center justify-center">
						<Button
							type="button"
							variant="ghost"
							size="icon"
							className="flex items-center justify-center hover:bg-destructive/10 rounded-full hover:text-destructive"
							onClick={() => onRemove?.()}
						>
							<Icon name="Trash2" className="size-5" />
						</Button>
					</div>
				</div>
			) : isHovered ? (
				<div className="absolute h-full w-16 right-0 bg-card flex items-center justify-center">
					<div className="h-full w-4 bg-linear-to-r from-transparent to-card" />

					<div className="h-full flex-1 flex items-center justify-center">
						<Link to={url} download>
							<Button type="button" variant="ghost" size="icon">
								<Icon name="Download" className="size-5" />
							</Button>
						</Link>
					</div>
				</div>
			) : null}
		</Card>
	);
}
